export const ultimateDebator=`

<p>Some methods of payment include an Ultimate debtor section. The section for Ultimate debtor is optional but should be used if the party making the payment is not the debit account owner â€“ i.e. for payments on behalf of another party (POBO).
</p>
<p>The Ultimate debtor fields which may be completed differ by payment type.</p>
<p><strong>CHAPS and International payments</strong></p>
<p>If you need to provide Ultimate debtor details on a CHAPS or International payment, please follow this guidance.</p>
<p>(<span style="color:red;">*</span>) If any Ultimate debtor fields are populated then as a minimum, Ultimate Debtor Name, Town/City and Country must be populated.</p>
<p>If any Ultimate debtor fields are populated, UDID, House/Building number, Street name, County/Region/Province, Postal code and BIC are optional fields.</p>

<p><img src='${process.env.PUBLIC_URL}/images/4/21/1.png'/></p>

</br>
<p>The table below shows the field lengths and permitted character set for each of the Ultimate debtor fields.</p>

<table class="table table-bordered">
<tbody>

<tr>
<td valign="center" align="center"><p><strong>Ultimate Debtor Field Label</strong></p></td>
<td valign="center" align="center"><p><strong>Field Length</strong></p></td>
<td valign="center" align="center"><p><strong>Field Type</strong></p></td>
<td valign="center" align="center"><p><strong>Character Set</strong></p></td>
</tr>

<tr>
<td><p>UDID</p></td>
<td align="center"><p>0-35</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

<tr>
<td><p>Name (*)</p></td>
<td align="center"><p>0-35</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

<tr>
<td><p>House / Building number</p></td>
<td align="center"><p>0-16</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

<tr>
<td><p>Street name</p></td>
<td align="center"><p>0-35</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

<tr>
<td><p>Town / City (*)</p></td>
<td align="center"><p>0-35</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

<tr>
<td><p>Country / Region / Province</p></td>
<td align="center"><p>0-35</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

<tr>
<td><p>Postal Code</p></td>
<td align="center"><p>0-16</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

<tr>
<td><p>BIC</p></td>
<td align="center"><p>0-11</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

<tr>
<td><p>Country (*)</p></td>
<td align="center"><p>2</p></td>
<td><p>ISO Country code</p></td>
<td><p>2 alpha characters in the Country Dropdown List</p></td>
</tr>

</tbody>
</table>
</br>
<p><strong>SEPA CT payment</strong></p>
<p>If you need to provide Ultimate debtor details on a SEPA CT payment, please follow this guidance.</p>
<p>If any Ultimate debtor fields are populated, the following field combinations are supported:</p>
<ul>
<li>UD Name only</li>
<li>UD BIC only</li>
<li>UD ID only</li>
<li>UD Name plus UD BIC</li>
<li>UD Name plus UD ID</li>
</ul>

<p><img src='${process.env.PUBLIC_URL}/images/4/21/2.png'/></p>

<p>The table below shows the field lengths and permitted character set for each of the Ultimate debtor fields.</p>

<table class="table table-bordered">
<tbody>

<tr>
<td valign="center" align="center"><p><strong>Ultimate Debtor Field Label</strong></p></td>
<td valign="center" align="center"><p><strong>Field Length</strong></p></td>
<td valign="center" align="center"><p><strong>Field Type</strong></p></td>
<td valign="center" align="center"><p><strong>Character Set</strong></p></td>
</tr>

<tr>
<td><p>UDID</p></td>
<td><p>0-35</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

<tr>
<td><p>Name</p></td>
<td><p>0-35</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

<tr>
<td><p>BIC</p></td>
<td><p>0-11</p></td>
<td><p>Alphanumeric</p></td>
<td><p>(A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p></td>
</tr>

</tbody>
</table>

`;


// WEBPACK FOOTER //
// ./src/components/content/payments/21-ultimateDebator.ts